<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('shopAudit.queryConditions') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="shopAuditInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-form-item>
              <el-input :placeholder="$t('shopAudit.shopName')" v-model="shopAuditInfo.conditions.shopName"></el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-input :placeholder="$t('shopAudit.returnPerson')"
                v-model="shopAuditInfo.conditions.returnPerson"></el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-input :placeholder="$t('shopAudit.returnLink')"
                v-model="shopAuditInfo.conditions.returnLink"></el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-select v-model="shopAuditInfo.conditions.state" style="width:100%"
                :placeholder="$t('shopAudit.state')">
                <el-option :label="$t('shopAudit.allStatus')" value=""></el-option>
                <el-option :label="$t('shopAudit.pendingAudit')" value="001"></el-option>
                <el-option :label="$t('shopAudit.auditPassed')" value="002"></el-option>
                <el-option :label="$t('shopAudit.auditFailed')" value="003"></el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="_queryShopAuditMethod" icon="el-icon-search">
              {{ $t('common.search') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('shopAudit.title') }}</div>
      </div>
      <div class="">
        <el-table :data="shopAuditInfo.shopAudits" border style="width: 100%">
          <el-table-column prop="auditId" :label="$t('shopAudit.auditId')" align="center"></el-table-column>
          <el-table-column prop="shopName" :label="$t('shopAudit.shopName')" align="center"></el-table-column>
          <el-table-column prop="sendAddress" :label="$t('shopAudit.deliveryAddress')" align="center"></el-table-column>
          <el-table-column prop="returnPerson" :label="$t('shopAudit.returnContact')" align="center"></el-table-column>
          <el-table-column prop="returnLink" :label="$t('shopAudit.returnPhone')" align="center"></el-table-column>
          <el-table-column prop="state" :label="$t('shopAudit.auditStatus')" align="center">
            <template slot-scope="scope">
              {{ _auditState(scope.row.state) }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('shopAudit.operation')" align="center">
            <template slot-scope="scope">
              <el-button size="mini" @click="_openAuditOpenShopModel(scope.row)">
                {{ scope.row.state === '001' ? $t('common.audit') : $t('common.view') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page.sync="shopAuditInfo.conditions.page"
          :page-size="DEFAULT_ROWS" layout="total, prev, pager, next" :total="shopAuditInfo.total"></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryShopAudit } from '@/api/shop/shopAuditApi'

const DEFAULT_PAGE = 1
const DEFAULT_ROWS = 10

export default {
  name: 'ShopAudit',
  data() {
    return {
      shopAuditInfo: {
        shopAudits: [],
        total: 0,
        records: 1,
        moreCondition: false,
        shopId: '',
        conditions: {
          auditId: '',
          storeId: '',
          returnLink: '',
          returnPerson: '',
          shopName: '',
          state: '',
          page: DEFAULT_PAGE,
          row: DEFAULT_ROWS
        }
      }
    }
  },
  created() {
    this._listShopAudits(DEFAULT_PAGE, DEFAULT_ROWS)
  },
  methods: {
    async _listShopAudits(page, rows) {
      this.shopAuditInfo.conditions.page = page
      this.shopAuditInfo.conditions.row = rows

      try {
        const res = await queryShopAudit(this.shopAuditInfo.conditions)
        this.shopAuditInfo.total = res.total
        this.shopAuditInfo.records = res.records
        this.shopAuditInfo.shopAudits = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _openAuditOpenShopModel(shopAudit) {
      this.$router.push({
        path: '/pages/shop/shopAuditDetail',
        query: {
          auditId: shopAudit.auditId,
          shopId: shopAudit.shopId
        }
      })
    },
    _auditState(state) {
      const states = {
        '001': this.$t('shopAudit.pendingAudit'),
        '002': this.$t('shopAudit.auditPassed'),
        '003': this.$t('shopAudit.auditFailed')
      }
      return states[state] || state
    },
    _queryShopAuditMethod() {
      this._listShopAudits(DEFAULT_PAGE, DEFAULT_ROWS)
    },
    handleCurrentChange(currentPage) {
      this._listShopAudits(currentPage, DEFAULT_ROWS)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.ibox-title {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.ibox-content {
  padding: 20px;
}
</style>